import React from 'react';
import { Center, Stack, Text, Button, Title } from '@mantine/core';

export default function StartupError() {
    return (
        <Center h="100vh">
            <Stack align="center" gap="md">
                <Title order={2}>Failed to load the application.</Title>
                <Text c="dimmed">Could not fetch the required permissions. Please try refreshing.</Text>
                <Button onClick={() => window.location.reload()}>
                    Refresh page
                </Button>
            </Stack>
        </Center>
    );
}
